/* eslint-disable */

import { StyleSheet } from 'aphrodite'
import React, { useState } from 'react'
import { useLoad } from "../../hooks/request";
import { useQueryParams } from "../../hooks/queryString";
import Button from "../../components/common/Button";
import { useModal } from "../../hooks/modal";
import Layout from "../../components/Layout";
import { CONTRACT_LIST } from "../../urls";
import ContractCreate from "./ContractCreate";
import ContractItem from "./ContractItem";
import BuildingTabs from "../../components/BuildingTabs";
import Table from "../../components/common/Table";


export default function Contract() {
    const [page, setPage] = useState(1)
    const [params, setParams] = useState({})

    const searchParam = useQueryParams()
    const contract = useLoad({
        url: CONTRACT_LIST,
        params: { page, ...params, ...searchParam }
    }, [searchParam, page, params])

    const productList = contract.response ? contract.response.results : []
    const [showCreateModal, setShowCreateModal] = useModal(<ContractCreate expenseReport={contract}
                                                                           onCancel={() => setShowCreateModal()}/>, styles.modal)

    return (
        <Layout showCreateModal={showCreateModal}>

            <div className="is-flex is-justify-content-space-between mb-3 is-align-items-center">
                <h2 className="title is-size-4">Шартномалар</h2>
                <Button text="Қўшиш" className="button is-link is-outlined" onClick={showCreateModal}/>
            </div>
            <BuildingTabs/>

            <div>
                <div className="mt-4 mb-4">
                    <Table
                        loading={contract.loading}
                        items={productList}
                        columns={{
                            index: '№',
                            customer: 'Мижоз',
                            dd32date: 'Квартира',
                            startDate: 'Бошлаш вақти',
                            endDate: 'Тугатиш вақти',
                            remainingAmount: 'Қолган сумма',
                            buttons: ''
                        }}
                        totalCount={contract.response ? contract.response.count : 0}
                        activePage={page}
                        onPageChange={setPage}
                        renderItem={(item, index) =>
                            <ContractItem
                                contract={contract}
                                index={index}
                                key={item.id}
                                item={item}/>}
                    />
                </div>
            </div>
        </Layout>
    )
}

const styles = StyleSheet.create({
    space: { marginTop: '2rem' },
    emptyImg: { width: '330px', height: '300px' },
    loader: { marginTop: '2rem' },
    modal: { width: 800 },
    checkmark: { marginRight: '3px' },
})
